/**
 * NAIS report catalog — static metadata for all 52 Snapshot Surveys.
 *
 * Regenerated from the ingestion output. When new reports are added:
 *   1. Ingest to Pinecone via scripts/pineconeingest.py
 *   2. Upload PDF to Firebase Storage at nais-reports/{filename}
 *   3. Add an entry here with matching filename + metadata
 *
 * Generated: 2026-04-22
 */

export const NAIS_CATALOG = [
    {
  "filename": "NAISsnapshotSurveyDistributedLeadership041726.pdf",
  "title": "Distributed Leadership",
  "theme": "Org Structure",
  "date": "2026-04-17",
  "year": 2026,
  "pages": 8,   
  "size_kb": 357, // fill in actual KB (look in Finder)
  "blurb": "The National Association of Independent Schools (NAIS) surveyed member-school heads of school about distributed leadership practices at their school. Three hundred forty-six heads responded to the survey, which took place April 6 – 13, 2026, representing a 19% response rate."
  },
  {
    "filename": "NAISsnapshotSurveyAdmissions041326.pdf",
    "title": "Admissions",
    "theme": "Admissions",
    "date": "2026-04-13",
    "year": 2026,
    "pages": 10,
    "size_kb": 347,
    "blurb": "The National Association of Independent Schools (NAIS) surveyed member-school admissions officers about admissions for the 2026-2027 school year. Three hundred seventy-six admissions officers responded to the survey, which took place April 6 – 9, 2026, representing a 30% response rate."
  },
    {
    "filename": "NAISsnapshotSurveyBoardUnderstanding031226.pdf",
    "title": "Board Understanding and Insight",
    "theme": "Board Relations",
    "date": "2026-03-12",
    "year": 2026,
    "pages": 8,
    "size_kb": 318.4,
    "blurb": "Nearly three-quarters (73%) of heads agreed or strongly agreed that their board has a realistic understanding of the school\u2019s market position and competitive challenges. About 57% agreed or strongly agreed that trustees understand enrollment trends, demand drivers, and how families make choices in their market."
  },
  {
    "filename": "NAISsnapshotSurveyTeacherRetention031126.pdf",
    "title": "Teacher Retention",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2026-03-11",
    "year": 2026,
    "pages": 9,
    "size_kb": 315.3,
    "blurb": "Over three-quarters (77%) of teachers planned to renew their contract for the next academic year. Among those who were not planning to do so, the top reasons were feeling stressed or burned out (18%) and lack of support from administration (17%)."
  },
  {
    "filename": "NAISsnapshotSurveyHeadHiring022026.pdf",
    "title": "Hiring Experiences of Heads of School",
    "theme": "Heads of School",
    "date": "2026-02-20",
    "year": 2026,
    "pages": 8,
    "size_kb": 295.5,
    "blurb": "Overall, heads of school report strong alignment between their expectations when hired and the reality of their roles. Four out of five heads (81%) agree or strongly agree that their current responsibilities reflect the job they believed they were hired to do, and fully 90% report that their actual decision- making authority aligns with what they expected."
  },
  {
    "filename": "NAISsnapshotSurveyFinancialAid013026.pdf",
    "title": "Financial Aid",
    "theme": "Financial Aid",
    "date": "2026-01-30",
    "year": 2026,
    "pages": 9,
    "size_kb": 312.8,
    "blurb": "About 40% of business officers reported receiving more requests for financial aid for 2025-2026 than the previous year, while 45% received about the same amount. While most schools (52%) kept the same budget for financial aid, 38% of business officers indicated they increased their budget up to 5% in anticipation of somewhat higher demand."
  },
  {
    "filename": "NAISsnapshotSurveyHeadBurnout013026.pdf",
    "title": "Understanding Head of School Burnout",
    "theme": "Heads of School",
    "date": "2026-01-30",
    "year": 2026,
    "pages": 8,
    "size_kb": 366.9,
    "blurb": "When asked about their stress levels, 82% of heads rated their stress as a six or higher on a scale of 10, where 10 represents extremely stressed. About a third (34%) of heads rated their stress as being higher or much higher than it has been in the past, and 27% rated it as being lower or much lower."
  },
  {
    "filename": "NAISsnapshotSurveyInsurance121225.pdf",
    "title": "Insurance",
    "theme": "Compensation & Benefits",
    "date": "2025-12-12",
    "year": 2025,
    "pages": 9,
    "size_kb": 324.4,
    "blurb": "The most common insurance policies held by independent schools are general liability (100%), workers\u2019 compensation (98%), and property insurance (97%). Most schools reported that they involve the school\u2019s chief financial officer (CFO)/business officer (97%) in the decision-making process for selecting insurance policies."
  },
  {
    "filename": "NAISsnapshotAIdivisionHeads112125.pdf",
    "title": "AI in Schools: Division Heads",
    "theme": "AI in Schools",
    "date": "2025-11-21",
    "year": 2025,
    "pages": 9,
    "size_kb": 341.8,
    "blurb": "Three-quarters (77%) of division heads said their school had either clear rules or general principles for student use of AI. Over half (56%) of division heads reported that their school had some sort of policy on faculty use of AI, either a general policy or a clear set of rules."
  },
  {
    "filename": "NAISsnapshotAIteachers112125.pdf",
    "title": "AI in Schools: Teachers",
    "theme": "AI in Schools",
    "date": "2025-11-21",
    "year": 2025,
    "pages": 9,
    "size_kb": 405.3,
    "blurb": "Close to three-quarters of teachers reported their school has either a clear set of rules that govern students\u2019 use of AI (22%) or generalized principles guiding usage (52%). Schools were less likely to have AI policies for faculty and staff, with only 9% of teachers having a clear set of rules that govern their usage of AI and 33% reporting they had general principles guiding their usage."
  },
  {
    "filename": "NAISsnapshotFacultyTurnoverHousing101325.pdf",
    "title": "Faculty Turnover and Housing",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2025-10-13",
    "year": 2025,
    "pages": 11,
    "size_kb": 322.4,
    "blurb": "Most schools (67%) reported having no unfilled positions this academic year. About 14% reported unfilled staff positions, 12% reported unfilled teaching positions, and 7% reported unfilled administrative positions."
  },
  {
    "filename": "NAIS Research_Snapshot Survey Enrollment_9.24.25.pdf",
    "title": "Enrollment",
    "theme": "Enrollment",
    "date": "2025-09-24",
    "year": 2025,
    "pages": 7,
    "size_kb": 304.4,
    "blurb": "About 30% of admission officers reported no significant change in enrollment for 2025-2026, while 43% reported some level of increase in enrollment. Of those schools that enrolled international students (about 43% of all schools reporting), 25% reported no significant change in the number of international students enrolled for 2025-2026."
  },
  {
    "filename": "NAISsnapshotSurveyEmploymentPlans050225.pdf",
    "title": "Employment Plans for 2025-2026",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2025-05-02",
    "year": 2025,
    "pages": 7,
    "size_kb": 331.1,
    "blurb": "About 97% of heads held a permanent headship, while 3% served as interim head. Most heads (89%) planned to stay in their current headship for the upcoming school year."
  },
  {
    "filename": "NAISsnapshotAdmission040425.pdf",
    "title": "Admissions",
    "theme": "Admissions",
    "date": "2025-04-04",
    "year": 2025,
    "pages": 9,
    "size_kb": 276.0,
    "blurb": "Over a third of schools (34%) had the same number of applications for 2025-2026 as the previous year. About 30% experienced some level of decrease in applications and 35% experienced an increase."
  },
  {
    "filename": "NAISsnapshotSurveyFedActEmp033125.pdf",
    "title": "Impact of Federal Actions on",
    "theme": "Federal/Policy Impact",
    "date": "2025-03-31",
    "year": 2025,
    "pages": 8,
    "size_kb": 283.2,
    "blurb": "Nearly three in 10 business officers (29%) reported that families at their school have experienced a change in employment status due to recent actions within the federal government, while 37% were uncertain of any change in status. Of those business officers who were aware of change(s) in parents\u2019 employment status, 46% reported that families worked for the federal government and 26% worked for bu"
  },
  {
    "filename": "NAISsnapshotSurveyTeacherRetention021425.pdf",
    "title": "Teacher Retention",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2025-02-14",
    "year": 2025,
    "pages": 8,
    "size_kb": 279.1,
    "blurb": "About 95% of teachers reported working at the same school as the previous year. Most teachers (80%) planned on renewing their contract for the next academic year, while 16% were unsure."
  },
  {
    "filename": "NAISsnapshotSurveyFacultyBenefits021025.pdf",
    "title": "Staff and Faculty Benefits",
    "theme": "Compensation & Benefits",
    "date": "2025-02-10",
    "year": 2025,
    "pages": 8,
    "size_kb": 286.9,
    "blurb": "Most schools (92%) adhere to the federal Family and Medical Leave Act (FMLA) or a state-required leave program. Roughly 40% of schools offer a paid parental leave policy in addition to FMLA or a state-required leave program."
  },
  {
    "filename": "NAISsnapshotSurveyAppendixOrgCharts121624.pdf",
    "title": "Org Charts Appendix",
    "theme": "Org Structure",
    "date": "2024-12-16",
    "year": 2024,
    "pages": 16,
    "size_kb": 2468.2,
    "blurb": "NAIS Snapshot Survey on Reporting Structures Conducted December 9-11, 2024 Organization Charts Heads of school sent these organization charts to NAIS as part of the snapshot survey on reporting structures conducted December 9-11, 2024. We have anonymized the charts shown below to represent a larger sample of charts."
  },
  {
    "filename": "NAISsnapshotSurveyReportingStructures121624.pdf",
    "title": "Reporting Structures",
    "theme": "Org Structure",
    "date": "2024-12-16",
    "year": 2024,
    "pages": 17,
    "size_kb": 2383.3,
    "blurb": "About 60% of heads of school reported they had between six and 10 direct reports. Almost 17% of heads reported having more than 12 direct reports."
  },
  {
    "filename": "NAISsnapshotSurveyFinancialAid112224.pdf",
    "title": "2024 Financial Aid",
    "theme": "Financial Aid",
    "date": "2024-11-22",
    "year": 2024,
    "pages": 6,
    "size_kb": 427.0,
    "blurb": "Most schools reported receiving the same amount (40%) or more (46%) requests for financial aid than previous years. About half (48%) of schools did not grow or shrink their budget, anticipating the same number of requests."
  },
  {
    "filename": "NAISsnapshotSurveyPhoneRegulations110124.pdf",
    "title": "2024 Phone Regulations",
    "theme": "Phone/Device Policy",
    "date": "2024-11-01",
    "year": 2024,
    "pages": 9,
    "size_kb": 452.7,
    "blurb": "Almost all (99%) responding division heads reported regulating or prohibiting student cell phone use on school grounds. Of the three schools that reported not doing so, two were drafting regulations or prohibition policies."
  },
  {
    "filename": "NAISsnapshotSurveyElectionCivilDiscourse101824.pdf",
    "title": "2024 Election Preparations",
    "theme": "DEIJ & Community Issues",
    "date": "2024-10-18",
    "year": 2024,
    "pages": 7,
    "size_kb": 515.4,
    "blurb": "October 14 \u2013 16, 2024 2024 Election Preparations at a Glance Key Takeaways by School Demographics The Na\ufffdonal Associa\ufffdon of Independent Schools (NAIS) surveyed member school heads about their schools\u2019 prepara\ufffdons for the upcoming 2024 U.S. Three hundred \ufb01\ufffdy-six heads responded to the survey, which took place October 14 \u2013 16, represen\ufffdng a 20% response rate."
  },
  {
    "filename": "NAISsnapshotSurveyOct7anniversary100424.pdf",
    "title": "10/7 Commemoration",
    "theme": "DEIJ & Community Issues",
    "date": "2024-10-04",
    "year": 2024,
    "pages": 2,
    "size_kb": 189.2,
    "blurb": "About 62% of independent schools did not plan to commemorate the anniversary of October 7. While 38% of schools did plan to, their plans varied greatly."
  },
  {
    "filename": "NAIS-Snapshot_Faculty-and-Staff-Turnover_9-26-24_1.pdf",
    "title": "Faculty and Staff Turnover",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2024-09-26",
    "year": 2024,
    "pages": 6,
    "size_kb": 451.1,
    "blurb": "September 19 \u2013 24, 2024 Faculty and Staff Turnover at a Glance Key Takeaways by School Demographics The Na\ufffdonal Associa\ufffdon of Independent Schools (NAIS) surveyed member-school heads about faculty and sta\ufb00 turnover in the 2024-2025 school year. Four hundred sixty-eight admission o\ufb03cers responded to the survey, which took place September 19 \u2013 24, represen\ufffdng a 29% response rate."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Enrollment_9-9-24.pdf",
    "title": "Enrollment",
    "theme": "Enrollment",
    "date": "2024-09-09",
    "year": 2024,
    "pages": 6,
    "size_kb": 431.6,
    "blurb": "August 27 \u2013 30, 2024 Enrollment at a Glance Key Takeaways by School Demographics The Na\ufffdonal Associa\ufffdon of Independent Schools (NAIS) surveyed member-school admission o\ufb03cers about enrollment trends for the 2024-2025 school year. Four hundred forty-one admission o\ufb03cers responded to the survey, which took place August 27 \u2013 30, represen\ufffdng a 29% response rate."
  },
  {
    "filename": "NAISsnapshotSurveyPhoneReg051024.pdf",
    "title": "Phone Regulation",
    "theme": "Phone/Device Policy",
    "date": "2024-05-10",
    "year": 2024,
    "pages": 7,
    "size_kb": 376.3,
    "blurb": "About 42% of respondents were middle school division heads, 20% lower school heads, and 38% upper school heads. Overall, 93% of participants reported that their school currently regulated or prohibited student cell phone use on school grounds or in classrooms."
  },
  {
    "filename": "NAISsnapshotSurveyAdmissions041524.pdf",
    "title": "Admissions",
    "theme": "Admissions",
    "date": "2024-04-15",
    "year": 2024,
    "pages": 7,
    "size_kb": 382.3,
    "blurb": "About 22% of schools reported receiving the same number of applications for 2024-2025 as the previous year and 46% reported an increase in applications. About six in 10 schools (57%) reported receiving the same number of applications from international students."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Bias_3-11-24.pdf",
    "title": "Antisemitism, Anti-Arab Bias, and Islamophobia",
    "theme": "DEIJ & Community Issues",
    "date": "2024-03-11",
    "year": 2024,
    "pages": 6,
    "size_kb": 428.7,
    "blurb": "Antisemitism, Anti- Arab Bias, and Islamophobia at a Glance Key Takeaways by School Demographics About 56% of schools with a boarding component reported that students had experienced anti-Arab bias, 30 percentage points higher than average. About 93% of girls\u2019 schools reported that they were developing inclusive curricula, compared to an average of 73%."
  },
  {
    "filename": "NAISsnapshotSurveyAIinClassrooms021224.pdf",
    "title": "AI in Classrooms",
    "theme": "AI in Schools",
    "date": "2024-02-12",
    "year": 2024,
    "pages": 7,
    "size_kb": 361.5,
    "blurb": "Key Takeaways by School Demographics January 29 \u2013 February 7, 2024 AI in Classrooms at a Glance The Na\ufffdonal Associa\ufffdon of Independent Schools (NAIS) surveyed member-school teachers about using ar\ufffd\ufb01cial intelligence (AI) in their classrooms. Six hundred seventy-\ufb01ve teachers responded to the survey, which took place January 29 \u2013 February 7, 2024, represen\ufffdng a 14% response rate."
  },
  {
    "filename": "NAIS-Research_Snapshot-Survey-Teacher-Wellbeing_12-8-23.pdf",
    "title": "Teacher Retention",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2023-12-08",
    "year": 2023,
    "pages": 6,
    "size_kb": 473.5,
    "blurb": "About 70% of teachers plan to renew their contract, while 26% are unsure and 4% will not. The main reasons teachers are not renewing their contract are feeling stressed or burned out (55%), salary too low (50%), and lack of support from administration (42%)."
  },
  {
    "filename": "NAISsnapshotSurvey102523.pdf",
    "title": "Financial Aid",
    "theme": "Financial Aid",
    "date": "2023-10-25",
    "year": 2023,
    "pages": 5,
    "size_kb": 347.5,
    "blurb": "Key Takeaways by School Demographics October 23 \u2013 25, 2023 Financial Aid at a Glance About 47% of secondary schools reported rewarding more financial aid awards to middle-income families compared to last year. The average for all member schools was 38%."
  },
  {
    "filename": "NAIS-Research_Snapshot-Survey-Hiring_9-26-23.pdf",
    "title": "Hiring",
    "theme": "Hiring",
    "date": "2023-09-26",
    "year": 2023,
    "pages": 7,
    "size_kb": 514.1,
    "blurb": "September 18 \u2013 20, 2023 Hiring at a Glance Key Takeaways by School Demographics The Na\ufffdonal Associa\ufffdon of Independent Schools (NAIS) surveyed member school heads about hiring prac\ufffdces and trends. Four hundred \ufb01ve heads responded to the survey, which took place September 18 \u2013 20, 2023, represen\ufffdng a 24% response rate."
  },
  {
    "filename": "NAISsnapshotSurvey082823.pdf",
    "title": "Enrollment",
    "theme": "Enrollment",
    "date": "2023-08-28",
    "year": 2023,
    "pages": 25,
    "size_kb": 738.3,
    "blurb": "Roughly 34% saw no significant change and 27% experienced a decrease in enrollment. Of the schools that enroll international students (half of all respondents), 63% of schools saw no significant change in international student enrollment between the 2022-2023 and 2023-2024 school years."
  },
  {
    "filename": "NAISsnapshotSurvey061223.pdf",
    "title": "Risk Management",
    "theme": "Security & Risk",
    "date": "2023-06-12",
    "year": 2023,
    "pages": 25,
    "size_kb": 508.4,
    "blurb": "About 21% do not have a process yet but are working on developing one. When it comes to developing their risk management plans, 29% of schools have worked with a consultant previously and 29% have developed their plans in-house."
  },
  {
    "filename": "NAISsnapshotSurveyUnions042823.pdf",
    "title": "Unions",
    "theme": "Unions",
    "date": "2023-04-28",
    "year": 2023,
    "pages": 5,
    "size_kb": 162.1,
    "blurb": "Nearly 96% of schools reported that none of their school employees are represented by a union. Among those that had employees represented by a union, 47% reported a state education union, 47% reported a local chapter of a national or international union, and 27% reported a union formed by the school\u2019s employees."
  },
  {
    "filename": "NAISsnapshotSurvey042423.pdf",
    "title": "Admissions",
    "theme": "Admissions",
    "date": "2023-04-24",
    "year": 2023,
    "pages": 21,
    "size_kb": 340.2,
    "blurb": "About 14% responded that they had seen a decrease of 10% or more in applications, while 16% reported an increase of 10% or more. A quarter of participants reported that the number of applications had remained the same."
  },
  {
    "filename": "NAISsnapshotSurvey041023.pdf",
    "title": "Stressors on Heads of Schools",
    "theme": "Heads of School",
    "date": "2023-04-10",
    "year": 2023,
    "pages": 26,
    "size_kb": 441.8,
    "blurb": "Confidence declined with boards\u2019 performance in regard to diversity, equity, inclusion, and justice (DEIJ) efforts: Only 51% of heads felt confident in boards\u2019 efforts to support DEIJ efforts and initiatives. When asked about school issues, three-quarters of heads said that they had to call an attorney between one and 15 times this academic year regarding a school issue."
  },
  {
    "filename": "NAISsnapshotSurveyChatGPT031723.pdf",
    "title": "ChatGPT in the Classroom",
    "theme": "AI in Schools",
    "date": "2023-03-17",
    "year": 2023,
    "pages": 26,
    "size_kb": 415.5,
    "blurb": "The sample differs from all schools in grade level and enrollment size, with elementary -secondary schools overrepresented and secondary schools underrepresented. Similarly, small schools (under 300 students) are underrepresented in this sample and large schools (over 500 students) are overrepresented."
  },
  {
    "filename": "NAISsnapshotSurveyTurnover021723.pdf",
    "title": "Faculty and Staff Turnover",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2023-02-17",
    "year": 2023,
    "pages": 26,
    "size_kb": 434.1,
    "blurb": "About a quarter (24%) have unfilled teaching positions and 20% are experiencing unfilled staff positions such as nurses and bus drivers. About 58% of schools have observed fewer applicants for jobs since the beginning of the 2022-2023 academic year."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Security-Measures_update_2-13-23.pdf",
    "title": "Security Measures",
    "theme": "Security & Risk",
    "date": "2023-02-13",
    "year": 2023,
    "pages": 26,
    "size_kb": 407.8,
    "blurb": "Nearly 88% of schools require visitors to sign in or wear a badge and 88% control access to school buildings and grounds during school hours. Also, 87% reported using one or more security cameras to monitor the school."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Head-Turnover_10-20-22.pdf",
    "title": "Head Turnover",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2022-10-20",
    "year": 2022,
    "pages": 19,
    "size_kb": 348.2,
    "blurb": "About 10% reported being unsure about their plans for next school year and 3% reported they planned to retire. The leading cause for the departure of the previous head of school was retirement (37%), followed by the previous head moving to a different independent school."
  },
  {
    "filename": "NAISsnapshotSurveyFinAid101422.pdf",
    "title": "Financial Aid",
    "theme": "Financial Aid",
    "date": "2022-10-14",
    "year": 2022,
    "pages": 28,
    "size_kb": 725.1,
    "blurb": "About 55% of schools reported that financial aid funds can only be used for tuition. The most common nontuition expenses that financial aid can be used for include extracurricular fees (26%), technology fees (25%), and books (24%)."
  },
  {
    "filename": "NAISsnapshotSurveyEnrollment092622.pdf",
    "title": "Enrollment",
    "theme": "Enrollment",
    "date": "2022-09-26",
    "year": 2022,
    "pages": 19,
    "size_kb": 331.1,
    "blurb": "About 31% of schools saw their enrollment for 2022-2023 increase by 5% or less compared to last year. Just 21% of schools saw their enrollment decrease by any percentage for the current year compared to the previous."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Faculty-Turnover_August-2022.pdf",
    "title": "Faculty and Staff Turnover",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2022-08-01",
    "year": 2022,
    "pages": 21,
    "size_kb": 362.1,
    "blurb": "Thirty-two percent of schools reported posting slightly more job openings for the current academic year compared to last year and 22% reported posting significantly more. When asked about strategies to improve teacher retention, schools reported implementing a variety of tactics."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Enrollment_7-18-22.pdf",
    "title": "Enrollment",
    "theme": "Enrollment",
    "date": "2022-07-18",
    "year": 2022,
    "pages": 24,
    "size_kb": 412.3,
    "blurb": "About 56% of schools reported meeting their enrollment goals for the 2022-2023 school year and 28% reported that they are on track to do so. About 16% of schools have not met their enrollment goals or are not on track to do so."
  },
  {
    "filename": "NAISsnapshotSurveyturnover061322.pdf",
    "title": "Staff/Faculty Turnover and Compensation",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2022-06-13",
    "year": 2022,
    "pages": 19,
    "size_kb": 383.3,
    "blurb": "Three quarters of schools responded that their faculty have expressed concerns about affordability moving forward with regards to inflation. Just over half of all schools reported that they had increased faculty salaries between 3% and 4.99% for 2022-2033."
  },
  {
    "filename": "NAISsnapshotSurvey050922_1.pdf",
    "title": "Board Relationship and Challenges",
    "theme": "Board Relations",
    "date": "2022-05-09",
    "year": 2022,
    "pages": 10,
    "size_kb": 217.1,
    "blurb": "Only 27% of heads report that their board has performed extremely well on handling diversity, equity, and inclusion (DEI) efforts and initiatives. The most common challenges facing heads are staff/faculty management (50% of heads rank this as a top challenge), navigating a changing COVID-19 landscape (34%), and political polarization/pushback (30%)."
  },
  {
    "filename": "NAISsnapshotSurvey042222.pdf",
    "title": "Advancement",
    "theme": "Advancement/Fundraising",
    "date": "2022-04-22",
    "year": 2022,
    "pages": 26,
    "size_kb": 328.1,
    "blurb": "Forty-five percent of schools currently conducting a capital campaign reported that their fundraising is currently right on target with projections, while 38% of schools reported fundraising behind projections. About half of schools report that donor retention has remained the same from last year, while smaller percentages report increases (28%) or decreases (24%) of repeat donors."
  },
  {
    "filename": "NAISsnapshotSurvey040422.pdf",
    "title": "Admissions",
    "theme": "Admissions",
    "date": "2022-04-04",
    "year": 2022,
    "pages": 26,
    "size_kb": 314.3,
    "blurb": "Roughly 30% of schools reported sending fewer acceptances than the previous year, while 26% of schools reported sending more acceptances. The upper grade levels sent fewer acceptances than others, with 33% of these schools reporting fewer acceptances sent to students in grades 9 \u2013 12 (compared to only 24% of school acceptances to kindergarten)."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Head-Turnover_3-18-22.pdf",
    "title": "Head Turnover",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2022-03-18",
    "year": 2022,
    "pages": 22,
    "size_kb": 336.6,
    "blurb": "Smaller numbers of schools have had three (20%) or more than three (11%) heads. Thirty-eight percent of schools\u2019 most recent head had retired, while 24% had moved to another school."
  },
  {
    "filename": "NAISsnapshotSurveyAdmissions021422.pdf",
    "title": "Admissions",
    "theme": "Admissions",
    "date": "2022-02-14",
    "year": 2022,
    "pages": 20,
    "size_kb": 402.9,
    "blurb": "However, 41% of schools that accepted international students in 2020-2021 had at least a few defer enrollment to the current 2021-2022 school year. Looking at applications by grade band, most schools are doing the same or better compared to last year."
  },
  {
    "filename": "NAISsnapshotSurveyTurnover021422.pdf",
    "title": "Staff and Faculty Turnover",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2022-02-14",
    "year": 2022,
    "pages": 31,
    "size_kb": 290.3,
    "blurb": "Sixty-six percent of schools have experienced a shortage in substitute teachers, while 51% had fewer applicants for jobs. Most schools reported teachers left for reasons that did not or only partially had to do with the COVID -19 pandemic."
  },
  {
    "filename": "NAIS-Snapshot-Survey_Holidays-and-Health_11-18-21.pdf",
    "title": "Holiday Plans and Health Policies",
    "theme": "Health & Safety",
    "date": "2021-11-18",
    "year": 2021,
    "pages": 13,
    "size_kb": 314.5,
    "blurb": "Nearly nine in 10 (89%) report at least one confirmed COVID-19 case this school year; 71% have had three or more cases this year, compared to 58% of schools surveyed last school year in December 2020. Independent schools are taking different approaches to COVID-19 testing post-winter break, with 30% requiring tests for all students, 26% encouraging tests, and 22% neither requiring nor encouraging "
  },
  {
    "filename": "NAISsnapshotSurvey110521.pdf",
    "title": "Retention and Well-Being",
    "theme": "Faculty/Staff Turnover & Retention",
    "date": "2021-11-05",
    "year": 2021,
    "pages": 21,
    "size_kb": 340.9,
    "blurb": "About 4% of heads report staff morale as extremely strong and 29% say it\u2019s very strong; this is an improvement from the fall of 2020, when 25% of heads reported extremely or very strong staff morale. More than three in four (77%) added duties to teachers\u2019 responsibilities since the start of the pandemic, while approximately three in five (61%) have removed responsibilities expected from teachers."
  },

];

export const NAIS_THEMES = [
  "Faculty/Staff Turnover & Retention",
  "Enrollment",
  "Admissions",
  "Financial Aid",
  "AI in Schools",
  "Heads of School",
  "DEIJ & Community Issues",
  "Board Relations",
  "Security & Risk",
  "Phone/Device Policy",
  "Org Structure",
  "Compensation & Benefits",
  "Health & Safety",
  "Advancement/Fundraising",
  "Unions",
  "Hiring",
  "Federal/Policy Impact",
];

export const NAIS_RESPONDENT_TYPES = [
  "heads",
  "teachers",
  "admission officers",
  "admissions leaders",
  "admissions officers",
  "division heads",
  "deij officers",
  "financial officers",
  "advancement leaders",
];

export const NAIS_YEARS = [2021, 2022, 2023, 2024, 2025, 2026];